import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../../assets/css/main.css";
import Profile_Image_PM_Modi from "../../assets/images/pm-modi.png";
import Profile_Image_Bhupendra_Patel from "../../assets/images/bhupendrabhai-patel.png";
import Profile_Image_Rushikesh_KJ from "../../assets/images/rushikesh-kj.png";
import Profile_Image_Praful_Pansheriya from "../../assets/images/Praful-Pansheriya.png";
import Profile_Image_Yagna_Shukla2 from "../../assets/images/yagna-shukla-2.png";
import Profile_Image_Nehal_Shah from "../../assets/images/nehal-shah.jpg";
import Profile_Image_Prakruti_Motka from "../../assets/images/Prakruti-Motka.png";
import NotificationPDF_1 from "../../assets/pdf/notifications/government-of-gujarat-letter.pdf";
import NotificationPDF_2 from "../../assets/pdf/notifications/notification-of-member.pdf";
import NotificationPDF_3 from "../../assets/pdf/notifications/allied-and-healthcare.pdf";
// import NotificationPDF_4 from "../../assets/pdf/notifications/member.pdf";
import NotificationPDF_5 from "../../assets/pdf/notifications/Suspension-Registration.pdf";
import NotificationPDF_6 from "../../assets/pdf/notifications/Allied-and-Healthcare-Curriculum-Implementation.pdf";
import NotificationPDF_7 from "../../assets/pdf/notifications/Curriculum-GSAHC-OT-MLT.pdf";
import NotificationPDF_8 from "../../assets/pdf/notifications/Allied-and-Healthcare-Courses.pdf";
import NotificationPDF_9 from "../../assets/pdf/notifications/GSAHC-Meeting-Uni-Inst.pdf";
import NotificationPDF_10 from "../../assets/pdf/notifications/allied-and-healthcare-Course-Admission-NEET.pdf";
import NotificationPDF_11 from "../../assets/pdf/notifications/A&HC-Admission-Criteria.pdf";
import NotificationPDF_12 from "../../assets/pdf/notifications/Implementation-of-GST.pdf";
import NotificationPDF_13 from "../../assets/pdf/notifications/Public-Notice-PT-and-OT.pdf";
// Announcement / Notification Updated pdfs
import file_09_04_2026_HC_Institutions_Course from "../../assets/pdf/notifications/09-04-2026-A-HC-Institutions-Course-Acadmic-Year-2026-2027.pdf";
import file_05_03_2026_Admission_Criteria_BPT_BOT from "../../assets/pdf/notifications/Admission-Criteria-BPT-BOT-Dt.05-03-2026.pdf";
import file_16_05_2026_UG_PG_COURSE from "../../assets/pdf/notifications/Intake Capacity for UG and PG Courses.pdf";
import file_13_07_2026_NCHAP from "../../assets/pdf/notifications/Admission and Supernumerary Seats of International Students in Diploma, Undergraduate and Postgraduate Allied and Healthcare Courses under NCAHP.pdf";
import file_18_07_2026_NCHAP from "../../assets/pdf/notifications/Public Notice- Allied and Healthcare.pdf";

import Banner1 from "../../assets/images/HomeBanner/new-banner1.jpg";
import Banner2 from "../../assets/images/HomeBanner/new-banner2.jpg";
import Banner3 from "../../assets/images/HomeBanner/new-banner3.JPG";
import Banner4 from "../../assets/images/HomeBanner/new-banner4.jpg";
import Banner5 from "../../assets/images/HomeBanner/new-banner5.JPG";
import Banner6 from "../../assets/images/HomeBanner/new-banner6.JPG";
import Banner7 from "../../assets/images/HomeBanner/new-banner7.JPG";
import Banner8 from "../../assets/images/HomeBanner/new-banner8.JPG";
import Banner9 from "../../assets/images/HomeBanner/new-banner9.JPG";
import Slider from "react-slick";
import { HomeBannerSettings } from "../../config/setting";
import New_Badge from "../../assets/images/new-bedge.svg";
import EventGallery from "../../components/EventGallery";

const Home = () => {
  document.title = "Home | Gujarat State Allied and Healthcare Council";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="wrappermain">
      {/* <section
        className="banner"
        style={{
          backgroundImage: `url(${Home_Background_Image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      > */}
      <div className="banner-bg">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="banner-slider-new">
                <Slider {...HomeBannerSettings}>
                  <div className="banner-slider">
                    <img src={Banner2} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner3} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner1} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner4} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner5} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner6} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner7} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner8} alt="Banner" className="img-fluid" />
                  </div>
                  <div className="banner-slider">
                    <img src={Banner9} alt="Banner" className="img-fluid" />
                  </div>
                </Slider>
              </div>
            </div>
            {/* <div className="col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
              <div className="banner-caption text-center">
                <div className="banner-caption-inner">
                  <img src={GSC_LOGO_New} className="banner-logo" alt="GSC Logo" />
                  <h2 className="banner-title">Gujarat State Allied and Healthcare Council</h2>
                  <p>Lorem ipsum dolor sit amet consectetur. Ullamcorper purus morbi quis pretium non</p>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* <div className="banner-caption">
            <h2>Gujarat State Allied and Healthcare Council</h2>
            <div className="banner-logo">
              <img src={BannerLogo} alt="" />
            </div>
          </div> */}
      </div>
      <div className="notification-box p-t-60 p-b-60">
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
              <div className="useful-links-box">
                <h3>Useful Links</h3>
                <div className="useful-links">
                  <a href="https://ncahp.abdm.gov.in/" target="_blank">
                    National commision for Allied and Healthcare professions
                  </a>
                  <hr />
                  <a href="https://gujhealth.gujarat.gov.in/" target="_blank">
                    Health and family welfare department - GOG
                  </a>
                  <hr />
                  <a
                    href="https://www.medadmgujarat.org/ga/home.aspx"
                    target="_blank"
                  >
                    Admission Committee
                  </a>
                </div>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
              <div className="announcement-box">
                <h3>Announcement & Notification</h3>
                <div className="announcement-links">
                  <ul>
                    {/* <li>
                      <a href={NotificationPDF_5} target="_blank">
                        July 31, 2025 - Suspension of Physiotherapy Registration
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_4} target="_blank">
                        July 25, 2025 - Inviting Applications for the post of members in GSAHC
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_3} target="_blank">
                        July 01, 2025 - Regarding use of term "Allied and Healthcare"
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_1} target="_blank">
                        April 01, 2025 - ફિઝીયોથેરાપી કાઉન્સિલની કામગીરી તબદીલ
                        કરવા બાબત...
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_2} target="_blank">
                        December 20, 2024 - Notification of GSAHC Members
                      </a>
                    </li> */}
                    <marquee
                      direction="up"
                      scrollamount="5"
                      behavior="scroll"
                      onMouseOver={(e) => e.currentTarget.stop()}
                      onMouseOut={(e) => e.currentTarget.start()}
                    >
                      <li>
                        <a
                          href={file_18_07_2026_NCHAP}
                          target="_blank"
                        >
                          <p>
                            July 18, 2026 - Public Notice - Regarding Use of term "Allied and Healthcare" 
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          href={file_13_07_2026_NCHAP}
                          target="_blank"
                        >
                          <p>
                            July 13, 2026 - Admission and Supernumerary Seats of International Students in Diploma, Undergraduate and Postgraduate Allied and Healthcare Courses under NCAHP
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          href={file_16_05_2026_UG_PG_COURSE}
                          target="_blank"
                        >
                          <p>
                            May 16, 2026 - Intake Capacity for various UG and PG Courses
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          href={file_09_04_2026_HC_Institutions_Course}
                          target="_blank"
                        >
                          <p>
                            April 9, 2026 - Allied & Healthcare
                            Institutions/Courses Reg.
                          </p>
                        </a>
                      </li>
                      <li>
                        <a
                          href={file_05_03_2026_Admission_Criteria_BPT_BOT}
                          target="_blank"
                        >
                          <p>March 5, 2026 - Admission Criteria-BPT & BOT</p>
                        </a>
                      </li>
                      <li>
                        <a href={NotificationPDF_13} target="_blank">
                          <p>
                            February 5, 2026 - Public Notice on Physiotherapy
                            and Occupational Therapy Professionals by NCAHP
                          </p>
                        </a>
                      </li>
                      <li>
                        <a href={NotificationPDF_12} target="_blank">
                          <p>
                            January 21, 2026 - Implementation of GST W.e.f 21st
                            January 2026
                          </p>
                        </a>
                      </li>
                      <li>
                        <a href={NotificationPDF_11} target="_blank">
                          <p>
                            January 12, 2026 - Admission criteria for Allied and
                            Healthcare professional programmes
                          </p>
                        </a>
                      </li>
                      {/* <li>
                        <a href={NotificationPDF_7} target="_blank">
                          <p>October 17, 2025 - Curriculum - OT and MLT </p>
                        </a>
                      </li> */}
                      {/* 
                      <li>
                        <a href={NotificationPDF_6} target="_blank">
                          <p>
                            August 26, 2025 - Implementation of Allied &
                            Healthcare Curriculum from Academic Year
                            2026-27{" "}
                          </p>
                        </a>
                      </li>
                      */}
                      <li>
                        <a href={NotificationPDF_3} target="_blank">
                          <p>
                            July 01, 2025 - Regarding use of term "Allied and
                            Healthcare"
                          </p>
                        </a>
                      </li>
                      {/* <li>
                        <a href={NotificationPDF_8} target="_blank">
                          <p>
                            June 13, 2025 - New Allied and Healthcare
                            Institutes/Courses Reg.
                          </p>
                        </a>
                      </li> */}
                      {/* 
                      <li>
                        <a href={NotificationPDF_1} target="_blank">
                          <p>
                            April 01, 2025 - ફિઝીયોથેરાપી કાઉન્સિલની કામગીરી
                            તબદીલ કરવા બાબત...
                          </p>
                        </a>
                      </li>
                      */}
                      <li>
                        <a href={NotificationPDF_2} target="_blank">
                          <p>
                            December 20, 2024 - Notification of GSAHC Members
                          </p>
                        </a>
                      </li>
                    </marquee>
                  </ul>
                </div>
              </div>
            </div>

            {/* <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
              <div className="announcement-box">
                <h3>Announcement & Notification</h3>
                <div className="announcement-links">
                  <ul>
                    <li>
                      <a href={NotificationPDF_5} target="_blank">
                        July 31, 2025 - Suspension of Physiotherapy Registration
                        <img
                          src={New_Badge}
                          alt="Announcement"
                          className="img-fluid"
                        />
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_4} target="_blank">
                        July 25, 2025 - Inviting Applications for the post of members in GSAHC
                        <img
                          src={New_Badge}
                          alt="Announcement"
                          className="img-fluid"
                        />
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_3} target="_blank">
                        July 01, 2025 - Regarding use of term "Allied and Healthcare"
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_1} target="_blank">
                        April 01, 2025 - ફિઝીયોથેરાપી કાઉન્સિલની કામગીરી તબદીલ
                        કરવા બાબત...
                      </a>
                    </li>
                    <li>
                      <a href={NotificationPDF_2} target="_blank">
                        December 20, 2024 - Notification of GSAHC Members
                      </a>
                    </li>
                  
                  </ul>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <section className="objective p-t-60 p-b-60">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
              <div className="objective-box text-center">
                <h2 className="section-title">Objective</h2>
                <p>
                  An Act to provide for regulation and maintenance of standards
                  of education and services by Allied and Healthcare
                  professionals, assessment of institutions, maintenance of a
                  Central Register and State Register and creation of a system
                  to improve access, research and development and adoption of
                  latest scientific advancement and for matters connected
                  therewith or incidental thereto.
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
              <div className="minister-info">
                <div className="minister-image">
                  <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <div className="minister-desc">
                        <img
                          src={Profile_Image_Bhupendra_Patel}
                          alt="Bhupendra Patel"
                          className="img-fluid"
                        />
                        <div className="minister-title">
                          <h3>Shri Bhupendra Patel</h3>
                          <span>Hon'ble Chief Minister, Govt. of Gujarat</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <div className="minister-desc">
                        <img
                          src={Profile_Image_Praful_Pansheriya}
                          alt="Praful Pansheriya"
                          className="img-fluid"
                        />
                        <div className="minister-title">
                          <h3>Shri Praful Pansheriya</h3>
                          <span>
                            Hon'ble Minister of Health & Family Welfare and
                            Medical Education, Govt. of Gujarat
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                      <div className="minister-desc">
                        <img
                          src={Profile_Image_Yagna_Shukla2}
                          alt="Dr. Yagna Unmesh Shukla"
                          className="img-fluid"
                        />
                        <div className="minister-title">
                          <h3>Dr. Yagna Unmesh Shukla</h3>
                          <span>Chairperson, NCAHP</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* </section> */}
      <section className="minister-info p-t-60 p-b-60">
        <div className="container minister-info-bg">
          <h2 className="text-center section-title">Welcome to GSAHC</h2>
          <div className="row">
            {/* <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7 left-div">
              <div className="minister-image">
                <div className="row">
                  <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="minister-desc">
                      <img
                        src={Profile_Image_Bhupendra_Patel}
                        alt="Bhupendra Patel"
                        className="img-fluid"
                      />
                      <div className="minister-title">
                        <h3>Shri Bhupendra Patel</h3>
                        <span>Hon'ble Chief Minister, Govt. of Gujarat</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="minister-desc">
                      <img
                        src={Profile_Image_Rushikesh_KJ}
                        alt="Rushikesh Patel"
                        className="img-fluid"
                      />
                      <div className="minister-title">
                        <h3>Shri Rushikesh Patel</h3>
                        <span>
                          Hon'ble Minister of Health & Family Welfare, Govt. of
                          Gujarat
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <div className="minister-desc">
                      <img
                        src={Profile_Image_Yagna_Shukla2}
                        alt="Dr. Yagna Unmesh Shukla"
                        className="img-fluid"
                      />
                      <div className="minister-title">
                        <h3>Dr. Yagna Unmesh Shukla</h3>
                        <span>Chairperson, NCAHP</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 right-div">
              <div className="counciler-msg">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="leadership-block">
                      <div className="leadership-pic">
                        <img
                          src={Profile_Image_Nehal_Shah}
                          alt="Dr. Nehal Shah"
                          className="img-fluid leader-image"
                        />
                        <div className="leader-desc">
                          <h3>Dr. Nehal P. Shah (PT)</h3>
                          <h4>Chairperson, GSAHC</h4>
                        </div>
                      </div>
                      <div className="bottom-title">
                        <p>
                          Our commitment to quality healthcare remains
                          unwavering as we work to make services more
                          accessible, innovative, and inclusive. With collective
                          effort and dedication, we are building a healthier,
                          stronger Gujarat where everyone receives the care they
                          deserve.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div className="leadership-block">
                      <div className="leadership-pic">
                        <img
                          src={Profile_Image_Prakruti_Motka}
                          alt="Dr. Nehal Shah"
                          className="img-fluid leader-image"
                        />
                        <div className="leader-desc">
                          <h3>Dr. Prakruti Motka(PT)</h3>
                          <h4>I/c Secretary, GSAHC</h4>
                        </div>
                      </div>
                      <div className="bottom-title">
                        <p>
                          Our mission is to regulate, standardize, and promote
                          the highest standards of education and professional
                          conduct in allied and healthcare services. We are
                          committed to supporting qualified professionals
                          through effective registration processes, continued
                          education, and ethical guidance.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Gallery Section */}
      <EventGallery />

      <section className="home-faq-main p-b-60">
        <div className="home-faq-main-banner">
          <div className="container p-t-120">
            <h2 className="text-center section-title">
              Categories under
              <br /> NCAHP Act
            </h2>
            <div className="faq-box-main">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div id="accordion">
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseone"
                        >
                          1. Medical Laboratory and Life Science
                        </a>
                      </div>
                      <div
                        id="collapseone"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Life Science Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Biotechnologist</td>
                                <td>2131</td>
                              </tr>
                              <tr>
                                <td>(ii) Biochemist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iii) Cell Geneticist</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iv) Microbiologist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(v) Molecular Biologist (nonclinical)</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(vi) Molecular Geneticist</td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Medical Laboratory Sciences Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Cytotechnologist </td>
                                <td>3212</td>
                              </tr>
                              <tr>
                                <td>(ii) Forensic Science Technologist </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iii) Histotechnologist</td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(iv) Hemato Technologist </td>
                                <td></td>
                              </tr>
                              <tr>
                                <td>(v) Medical Lab Technologist </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsetwo"
                        >
                          2. Trauma, Burn Care and Surgical/ Anesthesia related
                          technology
                        </a>
                      </div>
                      <div
                        id="collapsetwo"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Trauma and Burn Care Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Advance Care Paramedic </td>
                                <td>2240</td>
                              </tr>
                              <tr>
                                <td>(ii) Burn Care Technologist </td>
                                <td>2240</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Emergency Medical Technologist
                                  (Paramedic){" "}
                                </td>
                                <td>3258</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Surgical and Anaesthesia-related Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Anaesthesia Assistants and Technologists
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Operation Theatre (OT)Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Endoscopy and Laparoscopy Technologists
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsethree"
                        >
                          3. Physiotherapy Professional
                        </a>
                      </div>
                      <div
                        id="collapsethree"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          {/* <div className="d-flex justify-content-between pb-2">
                             <Link to={"/guidelines"} className="btn-login">Guidelines</Link>
                            <Link to={"/login"} className="btn-login">Login</Link>
                          </div> */}
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>Physiotherapist</td>
                                <td>2264</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsefour"
                        >
                          4. Nutrition Science Professional
                        </a>
                      </div>
                      <div
                        id="collapsefour"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Dietician (including Clinical Dietician,
                                  Food Service Dietician){" "}
                                </td>
                                <td>2265</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Nutritionist (including Public Health
                                  Nutritionist, Sports Nutritionist){" "}
                                </td>
                                <td>2265</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsefive"
                        >
                          5. Ophthalmic Sciences Professional
                        </a>
                      </div>
                      <div
                        id="collapsefive"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Optometrist</td>
                                <td>2267</td>
                              </tr>
                              <tr>
                                <td>(ii) Ophthalmic Assistant </td>
                                <td>3256</td>
                              </tr>
                              <tr>
                                <td>(iii) Vision Technician </td>
                                <td>3256</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsesix"
                        >
                          6. Occupational Therapy Professional
                        </a>
                      </div>
                      <div
                        id="collapsesix"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>Occupational Therapist </td>
                                <td>2269</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseseven"
                        >
                          7. Community Care, Behavioural Health Sciences and
                          other Professionals
                        </a>
                      </div>
                      <div
                        id="collapseseven"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Community Care </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Environment Protection Officer </td>
                                <td>2133</td>
                              </tr>
                              <tr>
                                <td>(ii) Ecologist </td>
                                <td>2133</td>
                              </tr>
                              <tr>
                                <td>(iii) Community Health promoters </td>
                                <td>3253</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Occupational Health and Safety Officer
                                  (Inspector){" "}
                                </td>
                                <td>3257</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Behavioural Health Sciences Professional
                                </th>
                                <th>ISCO Code </th>
                              </tr>

                              <tr>
                                <td>
                                  (i) Psychologist (Except Clinical Psychologist
                                  covered under RCI for PWD){" "}
                                </td>
                                <td>2634</td>
                              </tr>
                              <tr>
                                <td>(ii) Behavioural Analyst </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Integrated Behaviour Health
                                  Counsellor{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Health Educator and Counsellors including
                                  Disease Counsellors, Diabetes Educators,
                                  Lactation Consultants{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (v) Social workers including Clinical Social
                                  Worker, Psychiatric Social Worker, Medical
                                  Social Worker{" "}
                                </td>
                                <td>2635</td>
                              </tr>
                              <tr>
                                <td>
                                  (vi) Human Immunodeficiency Virus (HIV)
                                  Counsellors or Family Planning
                                  Counsellors{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(vii) Mental Health Support Workers </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>Other Care Professionals</th>
                                <th>
                                  <th>ISCO Code </th>{" "}
                                </th>
                              </tr>

                              <tr>
                                <td>(i) Podiatrist</td>
                                <td>2269</td>
                              </tr>
                              <tr>
                                <td>(ii) Palliative Care Professionals </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Movement Therapist (Including Art, Dance
                                  and Movement Therapist or Recreational
                                  Therapist)
                                </td>
                                <td>2269</td>
                              </tr>
                              <tr>
                                <td>(iv) Acupuncture Professionals</td>
                                <td>2230, 3230</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseeight"
                        >
                          8. Medical Radiology, Imaging and Therapeutic
                          Technology Professional
                        </a>
                      </div>
                      <div
                        id="collapseeight"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Medical Physicist </td>
                                <td>2111</td>
                              </tr>
                              <tr>
                                <td>(ii) Nuclear Medicine Technologist </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>
                                  (iii) Radiology and Imaging Technologist
                                  (Diagnostic Medical Radiographer, Magnetic
                                  Resonance Imaging (MRI), Computed Tomography
                                  (CT), Mammographer, Diagnostic Medical
                                  Sonographers){" "}
                                </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>(iv) Radiotherapy Technologist </td>
                                <td>3211</td>
                              </tr>
                              <tr>
                                <td>(v) Dosimetrist </td>
                                <td>3211</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapsenine"
                        >
                          9. Medical Technologists and Physician Associate
                        </a>
                      </div>
                      <div
                        id="collapsenine"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>
                                  Biomedical and Medical Equipment Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Biomedical Engineer </td>
                                <td>2149</td>
                              </tr>
                              <tr>
                                <td>(ii) Medical Equipment Technologist </td>
                                <td>3211</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Physician Associate or Physician
                                  Assistant{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Physician Associates </td>
                                <td>3256</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>
                                  Cardiovascular and Respiratory Technology
                                  Professional{" "}
                                </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>(i) Cardiovascular Technologists </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(ii) Perfusionist </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>(iii) Respiratory Technologist </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Electrocardiogram (ECG) Technologist or
                                  Echocardiogram (ECHO) Technologist{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                              <tr>
                                <td>
                                  (v) Electroencephalogram (EEG) or
                                  Electroneurodiagnostic (END) or
                                  Electromyography (EMG) Technologists or Neuro
                                  Lab Technologists or Sleep Lab
                                  Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                          <table className="table mt-3">
                            <tbody>
                              <tr>
                                <th>Renal Technology Professional </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Dialysis Therapy Technologists or Urology
                                  Technologists{" "}
                                </td>
                                <td>3259</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-header">
                        <a
                          className="collapsed card-link accordion-title"
                          data-toggle="collapse"
                          href="#collapseten"
                        >
                          10. Health Information Management and Health
                          Informatic Professional
                        </a>
                      </div>
                      <div
                        id="collapseten"
                        className="collapse"
                        data-parent="#accordion"
                      >
                        <div className="card-body">
                          <table className="table">
                            <tbody>
                              <tr>
                                <th>Profession </th>
                                <th>ISCO Code </th>
                              </tr>
                              <tr>
                                <td>
                                  (i) Health Information Management Professional
                                  (Including Medical Records Analyst){" "}
                                </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>
                                  (ii) Health Information Management
                                  Technologist{" "}
                                </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>(iii) Clinical Coder </td>
                                <td>3252</td>
                              </tr>
                              <tr>
                                <td>
                                  (iv) Medical Secretary and Medical
                                  Transcriptionist{" "}
                                </td>
                                <td>3344</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
